import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import BaseCardAction from '@/views/base/BaseCardAction.vue';
import BaseFormCard from '@/views/base/BaseFormCard.vue';
import { defineMessages } from '@/lib/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'BulkDeleteDialog',
  props: {
    value: { type: Boolean },
    selectedSdsCount: null
  },
  emits: ["input", "delete"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: boolean): void;
  (e: 'delete'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: boolean;
  selectedSdsCount: number;
};

const m = defineMessages({
  deleteConfirmation: '選択した{count}件を削除しますか?',
  executionWarning:
    '「実行する」をクリックすると、選択されたSDSファイルが削除されます。操作は取り消すことはできません。',
});




const model = computed({
  get: () => props.value,
  set: (value) => emit('input', value),
});

const closeDialog = () => {
  model.value = false;
};

const handleDeleteClick = () => {
  emit('delete');
  closeDialog();
};

const handleCancelClick = () => {
  closeDialog();
};

return { __sfc: true,m, props, emit, model, closeDialog, handleDeleteClick, handleCancelClick, BaseCardAction, BaseFormCard }
}

})